//@flow
export default {
  admin: {
    title: 'Administración',
    nav: {
      home: 'Casa',
      kiosks: 'Quioscos',
      sensors: 'Sensores',
      loops: 'Bucles',
      users: 'Usuarios',
      logout: 'Cerrar Sesión'
    },
    dashboard: {
      title: 'Tabelro',
      kiosks: {
        newButtonText: 'Nuevo Quiosco',
        viewAll: 'Todos los Quioscos',
        title: 'Quioscos',
        description:
          'Los usuarios del quiosco representan una instalación real de quiosco que tiene acceso a la interfaz de usuario del quiosco pero no esta herramienta de administración.'
      },
      attractLoops: {
        newButtonText: 'Nuevos Atraen Bucles',
        viewAll: 'Todos los Bucles',
        title: 'Atraer Bucles',
        description:
          'Los bucles de atracción se presentan en un quiosco individual, ya que es la vista inicial y / o protector de pantalla, mientras que un quiosco ha estado inactivo.'
      },
      users: {
        newButtonText: 'Nuevo Usuario',
        viewAll: 'Todos los Usuarios',
        title: 'Usuarios',
        description:
          'Los usuarios son administradores del sistema de kioscos en el que está conectado en este momento. A diferencia de los usuarios de Kiosk, los usuarios de administrador no acceden a la interfaz de usuario del quiosco en sí, sino sólo a este portal de administración para administrar el sistema.'
      },
      sensors: {
        newButtonText: 'Nuevo Sensor',
        viewAll: 'Todos los Sensores',
        title: 'Sensores',
        description:
          'Los sensores representan el equipo de calidad del aire y los datos que proporcionan de varios quioscos. Los sensores pueden combinarse con un quiosco para asegurar que son visualizaciones interactivas que proporcionan los datos correctos.'
      }
    }
  },
  kiosk: {
    language: {
      alternate: 'English',
      title: 'Switch to English?',
      subtitle: 'You can always go back to Spanish.',
      confirm: 'Yes',
      cancel: 'No'
    },
    confirmation: {
      title: {
        email: '¡Gracias!',
        phone: '¡Gracias!'
      },
      subtitle: {
        email: 'Acabamos de enviarte un enlace con más información.',
        phone: 'Acabamos de enviarle un enlace con más información.'
      },
      confirm: {
        email: 'Regresar al menú principal',
        phone: 'Regresar al menú principal'
      }
    },
    home: {
      title: '¿Qué tan importante es',
      emphasizedTitle: 'la calidad del aire?',
      description:
        'Aquí en [SHORT NAME] y ​​en todas partes en el Condado de Maricopa, todos tenemos una cosa en común: el aire que respiramos. ¡El adulto promedio inhala casi dos galones de aire por minuto y los niños respiran aún más!',
      callToAction:
        'Escoge un tema a continuación para obtener más información sobre nuestro aire y cómo puedes ayudar a mantenerlo limpio.',
      options: {
        current: 'Calidad de aire actual en',
        woodburning: 'Contaminación por',
        woodburning2: 'Leña',
        body: 'Efectos de Contaminación',
        body2: 'Atmosférica en su Cuerpo',
        commit: 'Acciones',
        commit2: 'Diarias',
        more: 'Dime',
        more2: 'más',
        survey: 'Participa en',
        survey2: 'una Encuesta'
      },
      begin: {
        initial: 'Empezar',
        dothis: '¡Hagámoslo!',
        thatsme: '¡Oye, ese soy yo!',
        resist: 'No puedo resistir'
      },
      loop: {
        title: {
          dothis: 'Cada vez que se toca esta pantalla,',
          thatsme: 'Solo toca esta pantalla',
          resist: 'Has sido elegido para'
        },
        subtitle: {
          dothis: 'nuestra calidad del aire mejora.',
          thatsme: 'si respiras.',
          resist: 'tocar esta pantalla.'
        }
      }
    },
    navigation: {
      home: 'Inicio',
      current: 'Calidad de\naire actual',
      woodburning: 'Contaminación\npor Leña',
      body: 'Efectos de\nContaminación Atmosférica',
      commit: 'Acciones\nDiarias',
      more: 'Dime\nmás',
      survey: 'Participa en\nuna Encuesta'
    },
    survey: {
      title: 'Participa e nuna Encuesta',
      close: 'Cerca',
      url: 'https://survey.sogosurvey.com/r/dmm2i2'
    },
    glossary: {
      pm2_5: {
        title: 'PM2.5:',
        subtitle: 'Contaminación de partículas finas',
        description:
          'PM2.5 es material particulado fino de menos de 2.5 micrómetros de diámetro que resulta de la combustión de vehículos de motor, generación de energía e instalaciones industriales, así como el humo de chimeneas residenciales y estufas de leña.',
        current: 'PM2.5 actual',
        status: {
          low:
            'Usted puede estar cerca de una fuente de contaminación de partículas como el polvo, el humo o el escape. Revise el Índice de Calidad del Aire para planificar actividades al aire libre.',
          medium:
            'Usted puede estar cerca de una fuente de contaminación de partículas como el polvo, el humo o el escape. Revise el Índice de Calidad del Aire para planificar actividades al aire libre.',
          high:
            'Puedes estar cerca de una fuente de contaminación de partículas como polvo, humo o gases de escape. Compruebe el Índice de la calidad del aire para planear actividades al aire libre.',
          veryhigh:
            'Usted puede estar cerca de una fuente de contaminación de partículas como el polvo, el humo o el escape. Revise el Índice de Calidad del Aire para planificar actividades al aire libre.',
          nodata: 'Actualmente no hay datos disponibles de nuestros sensores.'
        }
      },
      pm10: {
        title: 'PM10:',
        subtitle: 'Contaminación de partículas gruesas',
        description:
          'PM10 es una materia particulada mayor de 2.5 micras de diámetro y menos de 10 micras de diámetro que resulta de operaciones de trituración o molienda y polvo removido por vehículos en las carreteras.',
        current: 'PM10 actual',
        status: {
          low: 'Disfruta de tus actividades al aire libre.',
          medium:
            'Si las lecturas medias continúan (durante una hora o más), utiliza el índice de calidad del aire para planear actividades al aire libre.',
          high:
            'Puedes estar cerca de una fuente de contaminación de partículas como polvo, humo o gases de escape. Compruebe el Índice de la calidad del aire para planear actividades al aire libre.',
          veryhigh:
            'Puede estar cerca de una fuente de contaminación por partículas como polvo, humo o gases de escape. Consulte el índice de calidad del aire para averiguar si debe ajustar las actividades al aire libre. Lecturas muy altas pueden significar que el sensor no funciona correctamente.',
          nodata: 'Actualmente no hay datos disponibles de nuestros sensores.'
        }
      },
      o3: {
        title: 'Ozone:',
        subtitle: 'Contaminación de gas a nivel del suelo',
        description:
          'El ozono a nivel del suelo se forma cuando las emisiones de los vehículos, equipos de gasolina y diesel, procesos industriales y químicos y otras actividades diarias reaccionan a la luz solar.',
        current: 'Ozono actual',
        status: {
          low: 'Disfruta de tus actividades al aire libre.',
          medium:
            'Si las lecturas medias continúan (durante una hora o más), utiliza el índice de calidad del aire para planear actividades al aire libre.',
          high:
            'Si continúan las lecturas altas, considera re programar las actividades al aire libre. Verifica el índice de calidad del aire para averiguarlo. Lecturas muy altas pueden significar que el sensor no funciona correctamente.',
          veryhigh:
            'Puedes estar cerca de una fuente de contaminación por partículas como polvo, humo o gases de escape. Consulta el índice de calidad del aire para averiguar si debes ajustar las actividades al aire libre. Lecturas muy altas pueden significar que el sensor no funciona correctamente.',
          nodata: 'Actualmente no hay datos disponibles de nuestros sensores.'
        }
      }
    },
    forecast: {
      title: 'La calidad del aire importa.',
      intro:
        'La calidad de nuestro aire afecta cómo vives y respiras. Al igual que el clima, puede cambiar día a día, hora a hora y de un lugar a otro.',
      intro2:
        'Explore la calidad del aire aquí en [SHORT NAME], capturado cada 15 minutos con nuevas tecnologías de monitoreo en tiempo real, y ve cómo se compara con otras ubicaciones en todo el Valle.',
      cta: 'Toca los elementos para obtener más información.',
      forecastTitle: 'Calidad actual del aire en',
      forecastSubtitle:
        'La siguiente tabla muestra lecturas de la última hora.',
      countyTitle: 'Calidad del aire en el condado de Maricopa',
      description: {
        tbd:
          'No hay datos de pronóstico está disponible en este momento. Por favor, revise luego.',
        good: 'En este momento no hay restricciones en efecto',
        moderate:
          'Las personas sensibles deben tener cuidado al estar al aire libre',
        sensitive:
          'Las personas sensibles deben limitar sus actividades al aire libre',
        unhealthy: 'Todos deben limitar sus actividades al aire libre',
        very_unhealthy: 'Todos deben limitar sus actividades al aire libre',
        dangerous: 'Todos deben limitar sus actividades al aire libre'
      },
      status: {
        none: 'No hay restricciones en efecto',
        hpa: 'Aviso de Alta Contaminación',
        hw: 'Alerta de riesgo a la Salud'
      },
      buttons: {
        history: 'Ver historial',
        compare: 'Ubicaciones'
      },
      restrictions: {
        atv: {
          allowed: 'Vehículo todo terreno permitido',
          restricted: 'Vehículo todo terreno prohibido'
        },
        leafblower: {
          allowed: 'Sopladores permitidos',
          restricted: 'Sopladores prohibidos'
        },
        woodburning: {
          allowed: 'Permite la quema de leña',
          restricted: 'Quema de leña prohibido'
        }
      },
      metric: {
        pm2_5: {
          description: 'Partículas finas',
          name: 'PM 2.5'
        },
        o3: {
          description: 'Gas a nivel del suelo',
          name: 'Ozono'
        },
        pm10: {
          description: 'Partículas gruesas',
          name: 'PM 10'
        }
      },
      level: {
        high: 'Elevado',
        low: 'Bajo',
        medium: 'Medio',
        veryhigh: 'Muy alto',
        nodata: 'Sin datos'
      },
      conjunction: 'y',
      direction: {
        increasing: 'Aumentando',
        stable: 'Estable',
        decreasing: 'Disminuyendo'
      }
    },
    history: {
      title: 'Historia de la calidad del aire',
      subtitle:
        'Observa cómo las lecturas de contaminantes en [SHORT NAME] han cambiado durante la última semana.',
      close: 'Cerca',
      high: 'Elevado',
      low: 'Bajo',
      medium: 'Medio',
      veryhigh: 'Muy alto'
    },
    compare: {
      title: 'Comparar ubicaciones',
      subtitle:
        'Observa cómo las lecturas de contaminación del aire se comparan en todo el Valle.'
    },
    woodburning: {
      title: '¿Puede un tronco de leña realmente hacer daño a alguien?',
      intro:
        'Día de Año Nuevo, 2016. Mientras Phoenix se despierta lentamente en este fresco viernes de 36 grados ˚F, muchos están colocando un tronco de leña en su chimenea para comenzar el fin de semana festivo.',
      secondary:
        'Desliza el control de color verde para ver qué sucede en el horizonte de Phoenix durante la temporada de quema de leña en vacaciones de fin de año.',
      noburn: {
        title: '¿Día de "No Quemar"? ',
        subtitle: '¡No quemes madera!',
        description1:
          'Tanto la exposición a corto y largo plazo a la contaminación por partículas del humo que proviene de la leña se ha relacionado con una variedad de efectos sobre la salud, incluida la enfermedad pulmonar, los ataques de asma, la bronquitis aguda y las infecciones respiratorias.',
        description2:
          'Ayuda a mantener limpio nuestro aire y a nuestros vecinos saludables. Quemar Más Limpio, Quemar Mejor y no quemes leña o troncos de cera en un Día de "No Quemar".'
      }
    },
    body: {
      title: 'Contaminación del Aire y el Cuerpo',
      intro:
        'Al igual que fumar o los malos hábitos alimenticios, el aire contaminado representa una amenaza para nuestros cuerpos de muchas maneras. La contaminación del aire es peor en las grandes áreas metropolitanas como Phoenix, y causa una variedad de síntomas respiratorios, cardiovasculares y neurológicos.',
      cta: 'Toque los elementos para obtener más información.',
      nav: {
        neurological: {
          title: 'Efectos neurológicos',
          description:
            '¿No estás pensando en serio? Vea lo que la contaminación del aire le hace al cerebro.'
        },
        respiratory: {
          title: 'Efectos Respiratorios',
          description:
            '¿Cómo afecta la contaminación del aire a tus pulmones? Consejo: ¡Es peor que el tabaco!'
        },
        cardio: {
          title: 'Efectos Cardiovasculares',
          description:
            'Tum, tum, tum! La contaminación del aire afecta tu corazón de muchas maneras.'
        }
      },
      hotspots: {
        neuro: {
          one: {
            headline: 'Material Particulado y Derrame Cerebral',
            description:
              'La materia particulada, especialmente las partículas finas (PM2.5), aumenta el riesgo de derrame cerebral y la muerte por derrame cerebral, especialmente en el caso de las mujeres. Los datos de Iniciativa de Salud de la Mujer muestran que por cada incremento de 10μg / m3 en la concentración de PM2.5, las mujeres enfrentan un aumento del 35% en el riesgo de un evento cerebrovascular y un 83% de aumento en el riesgo de muerte por un evento cerebrovascular.'
          },
          two: {
            headline: 'Material Particulado y el Alzheimers',
            description:
              'La exposición a largo plazo a altas concentraciones de partículas puede disminuir el volumen cerebral total y aumentar los infartos, también conocidos como "ataques silenciosos". Un estudio demostró que a los 9 meses de exposición a partículas elevadas se observó un perfil de inflamación similar a la enfermedad de Alzheimer en el cerebro.'
          },
          three: {
            headline: '¿Te Sientes Cansado/a?',
            description:
              'Las altas concentraciones de ozono a nivel del suelo, el ingrediente principal del smog urbano y regional, pueden causar dolores de cabeza, náuseas, malestar general, fatiga y una menor resistencia a las infecciones.'
          }
        },
        cardio: {
          one: {
            headline: 'Pequeñas Partículas, Grandes Problemas',
            description:
              'La exposición a la materia particulada puede provocar cambios significativos en muchos índices cardiovasculares, como la frecuencia cardíaca, la variabilidad de la frecuencia cardíaca, la presión arterial y la coagulabilidad sanguínea. La contaminación de la materia particulada también se ha relacionado con la inflamación vascular, incluido un mayor riesgo de formación de coágulos sanguíneos y el estrechamiento de los vasos sanguíneos del corazón.'
          },
          two: {
            headline: 'Reconoce los Síntomas',
            description:
              'La opresión en el pecho, angina (dolor en el pecho), palpitaciones, dificultad para respirar y fatiga inusual son todos síntomas de los efectos de la contaminación del aire en nuestro sistema cardiovascular frágil y pueden conducir a un aumento de la enfermedad o muerte prematura por enfermedad arterial coronaria, ritmos cardíacos anormales, e insuficiencia cardíaca congestiva.'
          },
          three: {
            headline: 'Riesgos Cardiovasculares Para Mujeres',
            description:
              'De acuerdo con un estudio de 2007 publicado en la Revista de Medicina de Nueva Inglaterra, la contaminación de la materia particulada plantea una grave amenaza para las mujeres, produciendo un 76% MAYOR riesgo de enfermedad cardiovascular y muerte.'
          }
        },
        respiratory: {
          one: {
            headline: '¿Algo Está Ardiendo?',
            description:
              'Puede agradecer la contaminación del ozono a nivel del suelo, que está en su apogeo en los meses de verano de Arizona, por la quema de ojos, garganta y membranas mucosas irritadas.'
          },
          two: {
            headline: '¿Dificultad para respirar?',
            description:
              'La dificultad para respirar, los silbidos y la tos son síntomas comunes de la contaminación del aire. Los niños se encuentran entre los más vulnerables porque sus sistemas respiratorios aún se están desarrollando. Son más activos y pasan más tiempo al aire libre, inhalando más contaminación del aire por libra de peso corporal que los adultos.'
          },
          three: {
            headline: 'Toma una respiración profunda...',
            description:
              'La contaminación del aire, especialmente las partículas finas (PM 2.5), envejecen prematuramente sus pulmones estrechando las vías respiratorias y disminuyendo el flujo de aire. Esto puede conducir a un mayor riesgo de infección respiratoria y está relacionado con el aumento de la enfermedad y la muerte prematura por asma, bronquitis, enfisema y neumonía.'
          }
        }
      }
    },
    commit: {
      title: 'Ayuda a Mantener el Ozono Lejos ¡Comprométete por un Día!',
      intro:
        'Al hacer cambios fáciles en las actividades diarias al menos un día a la semana -reducir conducir, viajar en transporte público, reabastecer combustible después del anochecer o andar en bicicleta al trabajo- los residentes del Condado Maricopa pueden tener un gran impacto en la reducción de las concentraciones de ozono y en la limpieza del aire.',
      cta: 'Toca los iconos a continuación para obtener más información.',
      bike: {
        title: 'Andar en Bicicleta',
        intro:
          'Montar su bicicleta a lugares que normalmente conducir su coche. Obtenga un poco de aire fresco y ahorre algo de gas mientras reduce la contaminación del aire.'
      },
      ride: {
        title: 'Viajar en transporte Público',
        intro:
          'Utilizar modos alternativos de transporte. Considere la posibilidad de tomar el tren ligero, autobús o vanpool.'
      },
      walk: {
        title: 'Caminar',
        intro:
          'Reducir la contaminación del aire puede ser tan fácil como caminar a lugares cercanos en lugar de conducir. Aumente el número de pasos en su podómetro y mejore su salud.'
      },
      fuel: {
        title: 'Cargar gasolina en la noche',
        intro:
          'Las temperaturas calientes y los vapores de gasolina crean ozono a nivel del suelo. Reducir el efecto y reabastecer su vehículo en la noche.'
      },
      sweep: {
        title: 'Barrer',
        intro:
          'Barrer su entrada de autos, patio, cubierta, etc en lugar de utilizar un soplador de hojas. Haga ejercicio y respire aire fresco mientras que quema unas pocas calorías.'
      },
      idling: {
        title: 'Evitar el Ralentí',
        intro:
          'Evite el drive-thru y vaya adentro para pedir su comida, café o recetas. Usted no tendrá que esperar en una línea larga de la impulsión-a través y usted reducirá emisiones de escape.'
      },
      carpool: {
        title: 'Compartir Vehículo',
        intro:
          'Coche a la mayor cantidad de ubicaciones posibles. Montar juntos disminuye la cantidad de polvo y escape en el aire.'
      }
    },
    more: {
      title: '¿Podemos contar con usted?',
      intro:
        'Mantener nuestro aire limpio es un esfuerzo que depende de todos, y nos encantaría contarte más sobre cómo puedes involucrarte. Ingresa tu información y te enviaremos un enlace una sola vez dirigido a más información que solo está disponible para los usuarios de este kiosco. No te preocupes, no agregaremos tu nombre a ninguna lista de mercadeo a menos que lo solicites específicamente.',
      email: {
        placeholder: 'Tu Correo Electrónico',
        button: 'Enviar Correo Electrónico',
        errors: {
          required: 'No puede estar en blanco.',
          invalid: 'El correo electrónico es invalido'
        }
      },
      phone: {
        placeholder: 'Tu Número de Teléfono',
        disclaimer: '*puede aplicar tarifas de mensajes',
        button: 'Enviar Texto',
        errors: {
          required: 'No puede estar en blanco.',
          invalid: 'El teléfono no es válido'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Intl/messages/es-ES.js